var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function uploadFileHandler({ file, onSuccess, onError, constraints }) {
    return __awaiter(this, void 0, void 0, function* () {
        const constraint = yield validateConstraints(file, constraints);
        if (constraint) {
            return onError(constraint.message);
        }
        onSuccess();
        return file.name;
    });
}
function validateConstraints(file, constraints) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!constraints || !constraints.length) {
            return null;
        }
        for (const constraint of constraints) {
            const isPermitted = yield constraint.validator(file);
            if (!isPermitted) {
                return constraint;
            }
        }
        return null;
    });
}
